import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentImpacts, selectVulnDetail } from 'store/Manage/selectors';
import { updateVuln } from 'store/Manage/actions';
import Impacts from 'Common/Components/Impacts';
import ExpandableWrapper from '../ExpandableWrapper';
import Wrapper from './styled';
import useExpandable from 'Hooks/useExpandable';

const TAB = 'general';
const ID = 'impact';

const ImpactsTab = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const initialValue = useSelector(selectCurrentImpacts);
  const currentVuln = useSelector(selectVulnDetail);
  const [impacts, setImpacts] = useState(initialValue);

  const getDefaultValue = () => {
    return (
      impacts.accountability ||
      impacts.availability ||
      impacts.integrity ||
      impacts.accountability
    );
  };

  const isExpanded = useExpandable(TAB, ID, getDefaultValue());

  useEffect(() => {
    setImpacts(initialValue);
  }, [initialValue]);

  const onSelectCheckbox = (impactChanged) => {
    const newImpacts = { ...impacts, [impactChanged]: !impacts[impactChanged] };
    setImpacts(newImpacts);
    dispatch(updateVuln(currentVuln, 'impact', newImpacts));
  };

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'manage.detail.tab.general.impact' }) } tab={ TAB } id={ ID }>
      <Wrapper>
        <Impacts
          selectCheckbox={ onSelectCheckbox }
          hideTitle
          impacts={ impacts }
        />
      </Wrapper>
    </ExpandableWrapper>
  );
};

export default ImpactsTab;
